import { Component } from '@angular/core';
import { FinancialCalculator } from '@classes/financial';
import { endOfLocalDay, localDateInputValue, startOfLocalDay } from '@classes/dates';
import { PaymentService } from '@services/payment.service';

@Component({
  selector: 'app-trunk-show-report',
  templateUrl: './trunk-show-report.component.html',
  styleUrls: ['./trunk-show-report.component.css'],
})
export class TrunkShowReportComponent {
  rows: any[] = [];
  loading = false;
  startDate = '';
  endDate = '';
  displayedColumns = [
    'name',
    'vendorName',
    'framesSold',
    'grossNewBusiness',
    'discountAmount',
    'salesAfterDiscount',
    'averageSale',
  ];

  constructor(private paymentService: PaymentService) {
    const now = new Date();
    this.startDate = localDateInputValue(new Date(now.getFullYear(), now.getMonth(), 1));
    this.endDate = localDateInputValue(now);
  }

  load(): void {
    this.loading = true;
    this.paymentService.trunkShowReport(startOfLocalDay(this.startDate), endOfLocalDay(this.endDate)).subscribe({
      next: (rows) => {
        this.rows = rows || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  money(value: any): string {
    return FinancialCalculator.formatMoney(value);
  }
}
